const appConfig = {
    //routes
    apiPrefix: '/gateway',

    urlGateway: 'https://gateway.ethnixgroup.com:65315', //'https://testgateway.ethnixgroup.com:65319' , //https://gateway.ethnixgroup.com:65315,//'http://50.254.255.28:65319',//'http://192.168.1.14:9000', http://65.254.210.213:65315

    //default configuration 
    unAuthenticatedEntryPath: '/sign-in',
    tourPath: '/app/account/kyc-form',
    enableMock: true,
    //authenticatedEntryPath: '/app/sales/dashboard',
    authenticatedEntryPath: '/pages/welcome',
    locale: 'en',

    //Azure images
    AZURE_STORAGE_CONNECTION_STRING: "",
    AZURE_CONTAINER_NAME: "",
    AZURE_STORAGE_ACCOUNT_NAME: "",
    sasToken: "",
    PRICECHANGEPERC: 15,
    GOOGLE_ADDRESS_API_KEY: 'AIzaSyBxzdy6uj90dkGTG0ewkWTpfAUiWaKLr9I',

    // Customer-update-required gate (Sales Orders / Returns only): orders or
    // returns dated before this cutoff keep their action buttons even if the
    // customer still needs to be updated — only documents from this date
    // onward are blocked/badged. Format: 'YYYY-MM-DD'.
    CUSTOMER_UPDATE_CUTOFF_DATE: '2026-09-09',

    // Customer Update Dashboard: a customer counts as "buying" when its last
    // invoice is at most this many days old.
    CUSTOMER_BUYING_DAYS: 45
}

export default appConfig
